import { render, staticRenderFns } from "./DxStackedBarPlaned.vue?vue&type=template&id=4d45f15a&"
import script from "./DxStackedBarPlaned.vue?vue&type=script&lang=js&"
export * from "./DxStackedBarPlaned.vue?vue&type=script&lang=js&"
import style0 from "./DxStackedBarPlaned.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports